document.addEventListener("DOMContentLoaded", function () {
    const t = document.getElementById("countrySelect"),
        e = document.getElementById("flagIcon"),
        a = document.getElementById("ContactPhone"),
        n = t.selectedOptions[0].dataset.iso;
    (e.src = `https://flagcdn.com/24x18/${n}.png`),
        (a.value = t.value + " "),
        t.addEventListener("change", function () {
            const t = this.selectedOptions[0].dataset.iso,
                n = this.value;
            (e.src = `https://flagcdn.com/24x18/${t}.png`), a.value.startsWith(n) || ((a.value = n + " "), a.focus());
        });
}),
    document.addEventListener("DOMContentLoaded", function () {
         if (document.querySelector(".wt-parallax__slick")) {
            !(function t() {
                "undefined" != typeof $ && $.fn.slick
                    ?  $(".wt-parallax__slick").slick({
                          infinite: !0,
                          autoplay: !0,
                          autoplaySpeed: 5e3,
                          pauseOnHover: !0,
                          fade: !0,
                          speed: 1e3,
                          arrows: !0,
                          dots: !1,
                          prevArrow:
                              '<button type="button" class="slick-prev" aria-label="Previous slide"><svg class="svg-icon svg-icon--arrow-left " aria-hidden="true" id="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" data-icon-theme="option_4" width="72" height="72" viewBox="0 0 72 72">                    <title></title>                <g id="Arrow_left" data-name="Arrow left" transform="translate(-36 -511)">                <g id="arr_left" transform="translate(23289 11206)">                    <g id="Group_11367" data-name="Group 11367">                        <rect id="Rectangle_29189" data-name="Rectangle 2918" width="72" height="72" transform="translate(-23253 -10695)" fill="none"></rect>                        <path id="chevron-left" d="M35.628,87.789l.876-.876a1.487,1.487,0,0,0,0-2.1L12.281,60.587,36.5,36.365a1.487,1.487,0,0,0,0-2.1l-.876-.876a1.487,1.487,0,0,0-2.1,0L7.375,59.536a1.487,1.487,0,0,0,0,2.1l26.15,26.15a1.487,1.487,0,0,0,2.1,0Z" transform="translate(-23239.939 -10719.95)"></path>                    </g>                </g>            </g>        </svg></button>',
                          nextArrow:
                              '<button type="button" class="slick-next" aria-label="Next slide"><svg class="svg-icon svg-icon--arrow-right " aria-hidden="true" id="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" data-icon-theme="option_4" width="72" height="72" viewBox="0 0 72 72">                    <title></title>                <g id="Arrow_right" data-name="Arrow right" transform="translate(108 583) rotate(180)">                <g id="arr_right" transform="translate(23289 11206)">                    <g id="Group_11366" data-name="Group 11366">                        <rect id="Rectangle_291811" data-name="Rectangle 2918" width="72" height="72" transform="translate(-23253 -10695)" fill="none"></rect>                        <path id="chevron-right" d="M35.628,87.789l.876-.876a1.487,1.487,0,0,0,0-2.1L12.281,60.587,36.5,36.365a1.487,1.487,0,0,0,0-2.1l-.876-.876a1.487,1.487,0,0,0-2.1,0L7.375,59.536a1.487,1.487,0,0,0,0,2.1l26.15,26.15a1.487,1.487,0,0,0,2.1,0Z" transform="translate(-23239.939 -10719.95)"></path>                    </g>                </g>            </g>        </svg></button>',
                          responsive: [{ breakpoint: 768, settings: { arrows: !1, dots: !0 } }],
                      })
                    : setTimeout(t, 100);
            })();
        }
        // if (document.querySelector(".hotspot_slider")) {
        //     !(function t() {
        //         "undefined" != typeof $ && $.fn.slick
        //             ?  $(".hotspot_slider").slick({
        //                     infinite: true,
        //                     slidesToShow: 3,
        //                     slidesToScroll: 1,
        //                     autoplay: true,
        //                     autoplaySpeed: 5000,
        //                     pauseOnHover: true,
        //                     arrows: true,
        //                     dots: false,
        //                     speed: 1000,
        //                     responsive: [
        //                         {
        //                             breakpoint: 768, // for tablets and smaller
        //                             settings: {
        //                                 slidesToShow: 1,
        //                                 arrows: false,
        //                                 dots: true
        //                             }
        //                          }
        //                     ]
        //                 });
        //             : setTimeout(t, 100);
        //     })();
        // }
    });
